import { render, staticRenderFns } from "./AccountCertificateFormID.vue?vue&type=template&id=444b9167&scoped=true&"
import script from "./AccountCertificateFormID.vue?vue&type=script&lang=ts&"
export * from "./AccountCertificateFormID.vue?vue&type=script&lang=ts&"
import style0 from "./AccountCertificateFormID.vue?vue&type=style&index=0&id=444b9167&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444b9167",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
